import React from "react";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from "@heroui/react";
import { AiTwotoneDelete } from "react-icons/ai";


export default function ModalBox({
    title,
    children,
    handleConfirmUpdate,
    isOpen,
    onClose,
    confirmText = "Confirm",
    cancelText = "Cancel",
    isDelete = false,
    isLoading = false
}) {
    return (
        <>
            {/* <Button onPress={onOpen}>Open Modal</Button> */}
            <Modal backdrop='blur' isOpen={isOpen} onClose={onClose} isDismissable={false} isKeyboardDismissDisabled={false} >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1 border-b border-gray-100">
                                {isDelete ? (
                                    <div className="flex items-center gap-3"><AiTwotoneDelete size={25} /> {title}</div>
                                ) : title}
                            </ModalHeader>
                            <ModalBody className="p-0 py-4 px-6">
                                {children}
                            </ModalBody>

                            <ModalFooter className="border-t border-gray-100">
                                <Button color="primary" variant="flat" onPress={onClose}>
                                    <p className="text-primary-900">{cancelText}</p>
                                </Button>
                                <Button color="secondary" onPress={handleConfirmUpdate}>
                                    {isLoading ? (
                                        <Spinner color="success" size="sm" />
                                    ) : (
                                        <p className="text-black">{confirmText}</p>
                                    )}
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}